<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />
    <link rel="stylesheet" type="text/css" href="/css/integrations.css" />

    <script src="https://apis.google.com/js/client:platform.js?onload=initGoogle"></script>

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { createEventDispatcher } from "svelte";

    import {
        errorReasons,
        googleAuth,
        googleLocations
    } from "../api.svelte";


    const dispatch = createEventDispatcher();

    export let propertyId;
    export let data = false;

    let auth2;
    let googleInitialized = false;
    let googleAuthenticated = false;
    let locations = false;

    $: isLinked = () => {

        if (!data) return false;

        return Object.keys(data).includes('name');

    };


    onMount(() => {

        //

    });

    let handler = () => {};

    window.initGoogle = () => {

        if (googleInitialized) return;

        googleInitialized = true;

        gapi.load('auth2', function() {

            auth2 = gapi.auth2.init({

                client_id: '206386701356-9eh5nkihmqiuh7538lescnp7k1o8ga7h.apps.googleusercontent.com',
                scope: 'https://www.googleapis.com/auth/business.manage',
                immediate: true

            });

        });

    };

    let authHandler = () => {

        auth2.grantOfflineAccess().then(googleAuthenticate);
    };

    let googleAuthenticate = (auth) => {

        if (googleAuthenticated) {

            getLocations();
            return;

        }

        googleAuth(propertyId, auth['code']).then((authResult) => {

            if (authResult['status'] !== 'success') {

                // TODO: Handle errore
                console.log(authResult);
                return;

            }

            googleAuthenticated = true;

            getLocations();

        });

    };

    let getLocations = () => {

        googleLocations(propertyId).then((locationsResult) => {

            if (locationsResult['status'] !== 'success') {

                // TODO: Handle errore
                console.log(locationsResult);
                return;

            }

            let googleLocations = [];

            for (const [locationKey, location] of Object.entries(locationsResult['locations'])) {

                let locationItem = {
                    'id': location['id'],
                    'placeid': location['placeid'],
                    'name': location['name'],
                    'address': location['address'],
                    'account': location['account']
                };

                if (googleLocations.includes(locationItem)) {

                    continue;
                }

                googleLocations.push(locationItem);

            }

            locations = googleLocations;

        });

    };

    let onClosed = () => {

        dispatch('closed');
    };

    let onDeleted = () => {

        dispatch('deleted', {
            integration: 'google'
        });

    };

    let onSelected = (id, placeId, name, address, account) => {

        locations = false;

        dispatch('selected', {
            id: id,
            placeId: placeId,
            name: name,
            address: address,
            account: account
        });

    };

</script>


<form on:submit|preventDefault={() => handler()} id="googleform" class="forms">

    <div class="form-header">

        <img src="/images/icons/integrations/google.svg" />

        <span class="form-title">Google My Business</span>

    </div>

    {#if !isLinked()}

        {#if !locations}

            <div id="google-authentication">

                <button
                        class="btn-login btn-google"
                        on:click|preventDefault={() => authHandler()} >

                    <img src="/images/icons/integrations/login-google.png" />
                    <span>Mit Google anmelden</span>

                </button>

            </div>

            <div class="integration-buttons single">

                <button
                        class="btn half"
                        on:click|preventDefault={() => onClosed()} >

                    <span>Abschliessen</span>

                </button>

            </div>

        {:else}

            <div id="google-locations">

                <div id="locations-title">Wählen Sie einen My Business Standort</div>

                <div id="locations-results">

                    <img
                            on:click={() => locations = false}
                            src="/images/icon-close.svg"
                            class="locations-cancel" />

                    {#if locations.length < 1}

                        <div class="locations-item">

                            <span class="item-name">Keine Ergebnisse.</span>

                        </div>

                    {/if}

                    {#each locations as item}

                        <div
                                class="locations-item"
                                on:click={() => onSelected(item['id'], item['placeid'],
                                    item['name'], item['address'], item['account'])}>

                            <span class="item-name">{item['name']}</span>
                            <span class="item-address">{item['address']}</span>

                        </div>

                    {/each}

                </div>

            </div>

            <div class="integration-buttons single">

                <button
                        class="btn half"
                        on:click|preventDefault={() => locations = false} >

                    <span>Abschliessen</span>

                </button>

            </div>

        {/if}

    {:else}

        <div class="integration-view">

            <span id="title">{data['name']}</span>
            <span id="subtitle">{data['address']}</span>

        </div>

        <div class="integration-buttons">

            <button
                    class="btn danger half"
                    on:click|preventDefault={() => onDeleted()} >

                <span>Entfernen</span>

            </button>

            <button
                    class="btn half"
                    on:click|preventDefault={() => onClosed()} >

                <span>Abschliessen</span>

            </button>

        </div>

    {/if}

</form>


<style>

    .form-header img {
        width: 3.33vh;
        margin-right: 1.2vh;
    }

    button.btn-login.btn-google {
        display: flex;
        align-items: center;
        width: 31vh;
        padding: 1px;
        background-color: #4285F4;
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        color: white;
        border-radius: 0;
    }

    .btn-google img {
        width: 1.8vh;
        height: 1.8vh;
        padding: 0.9vh;
        border-radius: 1px;
        background-color: #FFFFFF;
    }

    .btn-google span {
        width: 28.3vh;
        font-size: 1.6vh;
    }

    #locations-title {
        font-family: 'Raleway', sans-serif;
        font-weight: 400;
        font-size: 1.48vh;
        text-align: left;
    }

    #locations-results {
        display: flex;
        flex-direction: column;
        max-height: 20vh;
        margin-top: 2.12vh;
        position: relative;
    }

    .locations-cancel {
        position: absolute;
        top: 1.9vh;
        right: 1.5vh;
        cursor: pointer;
        z-index: 99;
    }

    .locations-item {
        display: flex;
        flex-direction: column;
        width: 31vh;
        padding: 1.42vh;
        margin-bottom: 2.12vh;
        z-index: 9;
        font-size: 1.5vh;
        font-family: 'Raleway', sans-serif;
        text-align: left;
        cursor: pointer;
        border-radius: 1vh;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
    }

    .locations-item:last-child {
        margin-bottom: 0;
    }

    .locations-item .item-name {
        font-weight: 500;
    }

    .locations-item .item-address {
        font-weight: 400;
        font-size: 1.4vh;
    }

</style>
